import styles from "./styles.module.css";
import Container from "../Container";
import Button from "../Button";
import Label from "../Label";
import { ArrowLink } from "../Icons";
import Heading from "../Heading";
import Image from "next/image";
import Link from "next/link";
import { Download } from "../Icons";
import advisors from "./advisors.jpg";
import MyImage from "../MyImage";

const ResourceHero = ({
  title,
  backgroundUrl,
  categories,
  date,
  authors,
  avatarUrl,
  label,
  isDownloadable,
  isExternal,
  link,
  resourceType,
  presenters,
  partners,
  participants,
}) => {
  const scrollToAuthors = () => {
    document.querySelector("#authors").scrollIntoView({
      behavior: "smooth",
    });
  };
  return (
    <>
      <div className={styles.resourceHero}>
        {backgroundUrl && (
          <MyImage
            src={backgroundUrl}
            layout="fill"
            objectFit="cover"
            alt="background"
          />
        )}
        <div className={styles.content}>
          <div className={styles.top}>
            {!!categories.nodes.length && (
              <Label>{categories.nodes[0].name}</Label>
            )}
            <Label type="transparentWhite">{label}</Label>
          </div>
          <Heading size="big" color="white">
            {link ? (
              <Link href={link} passHref>
                <a>
                  <span className={styles.ellipsis}>{title}</span>
                  {isDownloadable && (
                    <span className={styles.download}>
                      <Download width="22" height="22" fill="var(--white)" />
                    </span>
                  )}
                  {isExternal && (
                    <span className={styles.external}>
                      <ArrowLink width="22" height="22" fill="var(--white)" />
                    </span>
                  )}
                </a>
              </Link>
            ) : (
              <>
                <span className={styles.ellipsis}>{title}</span>
                {isDownloadable && (
                  <span className={styles.download}>
                    <Download width="22" height="22" fill="var(--white)" />
                  </span>
                )}
                {isExternal && (
                  <span className={styles.external}>
                    <ArrowLink width="22" height="22" fill="var(--white)" />
                  </span>
                )}
              </>
            )}
          </Heading>
        </div>
      </div>
      <div className={styles.resourceDetails}>
        <p className={styles.date}>
          {date
            ? new Date(date).toLocaleDateString("en-US", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })
            : null}
        </p>
        <div className={styles.authors}>
          {false && resourceType === "report" && (
            <p className={styles.author} onClick={() => scrollToAuthors()}>
              <div className={styles.avatarWrapper}>
                <MyImage
                  src={advisors}
                  width="32"
                  height="32"
                  objectFit="cover"
                  layout="fill"
                  alt="advisors"
                />
              </div>
              Sustainable Capital Advisors
            </p>
          )}
          {resourceType === "speaking-engagement" &&
            presenters &&
            presenters.map((presenter, index) => (
              <div
                className={styles.author}
                onClick={() => scrollToAuthors()}
                key={index}
              >
                <div className={styles.avatarWrapper}>
                  <MyImage
                    src={presenter.avatar?.node?.sourceUrl}
                    width="32"
                    height="32"
                    objectFit="cover"
                    layout="fill"
                    alt={presenter.avatar?.node?.altText || presenter.avatar?.node?.title}
                  />
                </div>
                {presenter.name}
              </div>
            ))}
          {resourceType === "report" &&
            partners &&
            partners.map((partner, index) => (
              <div
                className={styles.author}
                onClick={() => scrollToAuthors()}
                key={index}
              >
                <div className={styles.avatarWrapper}>
                  <MyImage
                    src={partner.avatar?.node?.sourceUrl}
                    width="32"
                    height="32"
                    objectFit="cover"
                    layout="fill"
                    alt={partner.avatar?.node?.altText || partner.avatar?.node?.title}
                  />
                </div>
                {partner.name}f
              </div>
            ))}
          {authors &&
            resourceType !== "podcast" &&
            authors.map((author, index) => (
              <div
                className={styles.author}
                onClick={() => scrollToAuthors()}
                key={index}
              >
                <div className={styles.avatarWrapper}>
                  <MyImage
                    src={author.avatar?.node?.sourceUrl}
                    width="32"
                    height="32"
                    objectFit="cover"
                    layout="fill"
                    alt={author.avatar?.altText || author.avatar?.title}
                  />
                </div>
                {author.name}
              </div>
            ))}
          {resourceType === "podcast" &&
            participants &&
            participants.map((participant, index) => (
              <div
                className={styles.author}
                onClick={() => scrollToAuthors()}
                key={index}
              >
                <div className={styles.avatarWrapper}>
                  <MyImage
                    src={participant.avatar?.node?.sourceUrl}
                    width="32"
                    height="32"
                    objectFit="cover"
                    layout="fill"
                    alt={
                      participant.avatar?.node?.altText || participant.avatar?.node?.title
                    }
                  />
                </div>
                {participant.name}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default ResourceHero;
